<div class="header">
  <h2>Pilot Drug and Alcohol Records</h2>
  <button mat-raised-button (click)="add()">
    <mat-icon>add</mat-icon> <span>Add Drug and Alcohol Record</span>
  </button>
  <button mat-raised-button (click)="refresh()">
    <mat-icon>refresh</mat-icon>
  </button>
</div>
<div>
  <ng-template
    [flLoading]="loadingKey"
    [flLoadingUntil]="drugAlcoholRecords$ | async"
    flLoadingStrategy="overlay"
    flLoadingColor="primary"
  >
    <table mat-table [dataSource]="drugAlcoholRecords$" fxFlex="100">
      <ng-container matColumnDef="occurrenceDate">
        <th mat-header-cell *matHeaderCellDef>Occurrence Date</th>
        <td mat-cell *matCellDef="let drugAlcoholRecord">
          {{ drugAlcoholRecord.occurrenceDate | date : 'MM/dd/yyyy' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="recordType">
        <th mat-header-cell *matHeaderCellDef>Record Type</th>
        <td mat-cell *matCellDef="let drugAlcoholRecord">
          <ng-container *ngIf="drugAlcoholRecord.recordType$ | async as recordType">
            {{ recordType.displayName() }}
          </ng-container>
        </td>
      </ng-container>
      <ng-container matColumnDef="reportType">
        <th mat-header-cell *matHeaderCellDef>Report Type</th>
        <td mat-cell *matCellDef="let drugAlcoholRecord">
          <ng-container *ngIf="drugAlcoholRecord.reportType$ | async as reportType">
            {{ reportType.displayName() }}
          </ng-container>
        </td>
      </ng-container>
      <ng-container matColumnDef="testType">
        <th mat-header-cell *matHeaderCellDef>Test Type</th>
        <td mat-cell *matCellDef="let drugAlcoholRecord">
          <ng-container *ngIf="drugAlcoholRecord.testType$ | async as testType">
            {{ testType.displayName() }}
          </ng-container>
        </td>
      </ng-container>
      <ng-container matColumnDef="processingState">
        <th mat-header-cell *matHeaderCellDef>Processing State</th>
        <td mat-cell *matCellDef="let drugAlcoholRecord">
          {{ drugAlcoholRecord.processingState | humanize }}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastProcessedDate">
        <th mat-header-cell *matHeaderCellDef>Last Processed Date</th>
        <td mat-cell *matCellDef="let drugAlcoholRecord">
          {{ (drugAlcoholRecord.lastProcessedDate | date : 'MM/dd/yyyy HH:mm') || '--' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="processingError">
        <th mat-header-cell *matHeaderCellDef>Processing Error</th>
        <td mat-cell *matCellDef="let drugAlcoholRecord" class="prd-processing-error-text">
          {{ drugAlcoholRecord.processingError }}
        </td>
      </ng-container>
      <ng-container matColumnDef="prdSourceSystemId">
        <th mat-header-cell *matHeaderCellDef>PRD Source System Id</th>
        <td mat-cell *matCellDef="let drugAlcoholRecord">
          {{ drugAlcoholRecord.prdSourceSystemId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let drugAlcoholRecord">
          <button mat-icon-button [matMenuTriggerFor]="drugAlcoholRecordActions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #drugAlcoholRecordActions="matMenu">
            <a mat-menu-item (click)="edit(drugAlcoholRecord)"> <mat-icon>edit</mat-icon>Edit </a>
            <a mat-menu-item (click)="delete(drugAlcoholRecord.id)">
              <mat-icon>delete</mat-icon>Delete
            </a>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </ng-template>
</div>
<div>
  <mat-paginator
    (page)="onPage($event)"
    [length]="total$ | async"
    [pageSize]="defaultPageSize"
    [pageSizeOptions]="pageSizeOptions"
  >
  </mat-paginator>
</div>
